import PaymentMethod from './PaymentMethod';

export { default as PaymentMethodFormContext } from './context/PaymentMethodFormContext';

export default PaymentMethod;
